import type { SellerProfileDto } from './profileContracts'
import type { SellerProfile } from '../types/profileTypes'

// Names arrive in whatever case the seller typed at UAE Pass sign-up
// ("harshitji rathore"), so display-case them at the parser seam — every
// consumer then reads one consistently-cased name. Only the leading character
// is raised; a full title-case pass would flatten legitimately mixed-case
// surnames ("McDonald" → "Mcdonald").
function capitalizeFirstLetter(value: string): string {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}

// The seller record keeps the dialing code and the national number in two
// columns; every consumer wants one dial-able string, so they are joined here
// rather than at each call site. Both halves are required — a national number
// with no country code is not a number anyone can dial, and prefilling it into
// an international tel input would silently attach the wrong country.
function toE164Mobile(countryCode: string | null, nationalNumber: string | null): string {
  if (!countryCode || !nationalNumber) return ''
  return `${countryCode}${nationalNumber}`.replace(/[\s()\-.]/g, '')
}

export function parseSellerProfile(dto: SellerProfileDto): SellerProfile {
  const firstName = capitalizeFirstLetter(dto.firstName)
  const lastName = capitalizeFirstLetter(dto.lastName)
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim()
  return {
    id: dto.id,
    firstName,
    lastName,
    fullName,
    email: dto.email,
    mobileNumber: toE164Mobile(dto.phoneCountryCode, dto.phoneNumber),
    emiratesId: dto.emiratesId ?? '',
  }
}
